/* DSL Funnel tracking — log step transitions per session */
(function(){
  var STEPS = {"/": "home", "/collections/all": "browse", "/products/": "view_product", "/cart": "cart", "/checkouts/": "checkout"};
  var current = null;
  Object.keys(STEPS).forEach(function(p){
    if (location.pathname.indexOf(p) === 0 || location.pathname === p) current = STEPS[p];
  });
  if (!current) return;
  if (window.DSL_AB) window.DSL_AB.track("funnel_step", {step: current, ts: Date.now()});
})();